module.exports = __webpack_public_path__ + "static/media/tmc_logo_with_text.955194dd.png";